import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import Routes from "./routes";
import Layout from "./components/Layout";

import "./components/assets/css/form.css";

const App: React.FC = () => (
  <AuthProvider>
    <Layout>
      <Routes />
    </Layout>
  </AuthProvider>
);

export default App;
